export default function WorkGallery3() {
  return (
    <section className="py-10">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0 flex flex-col gap-4">

        {/* Row 1 */}
          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro7.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro1.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro2.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/bistro15.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

        {/* Row 2 */}
        

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro3.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro4.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

        {/* Row 3 */}
          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro5.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro6.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/bistro16.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro7.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

        {/* Row 4 */}
          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro8.jpg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro9.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro10.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/bistro17.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro11.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro12.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro13.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/bistro18.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/bistro14.jpg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <video
              src="/bistro19.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover block"
            />
          </div>

      </div>
    </section>
  );
}